import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../../authConfig";
import { Icon } from "@iconify/react";
import { loginWithO365 } from "../../../callApi/httpservice";
import "../../../assets/css/DatePickerAdmin.css";
import HeaderAdmin from "../../../components/admin/Header";
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import SpinnerCustom from "../../../components/common/SpinnerCustom";
function LoginMS() {
  const [isWaiting, setIsWaiting] = useState<boolean>(false);
  const hashcode = new URLSearchParams(useLocation().search).get("hashcode");
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();
  async function onSigninClick() {
    instance.loginRedirect(loginRequest);
  }

  const loginMscServer = async (result: any) => {
    const userDto = {
      email: result.account?.username || "",
      accessTokenMs: result.accessToken,
      name: result.account?.name || "",
      token: hashcode || null,
    };
    let user: any;
    try {
      user = await loginWithO365(userDto);
    } catch (err: any) {
      // need remove cookies
      if (err.response.status === 400) {
        toast.error("Invalid token for this account");
      } else if (err.response.status === 404) {
        toast.error("Your account has not been added by an administrator");
      } else {
        toast.error("Invalid your account, contact admin");
      }
      setIsWaiting(false);
      sessionStorage.clear();
      instance.logoutRedirect(loginRequest);
    }
    if (user) {
      user.data.role = window.btoa(user.data.role);
      localStorage.setItem("infoSignin", JSON.stringify({ ...user.data }));
      navigate("/");
    }
  };
  useEffect(() => {
    setIsWaiting(false);
    // check if there is an account
    if (accounts.length > 0) {
      setIsWaiting(true);
      const account = accounts[0];
      instance
        .acquireTokenSilent({
          scopes: ["user.read"],
          account: account,
        })
        .then((result) => {
          localStorage.setItem(
            "homeAccountId",
            JSON.stringify(result.account?.homeAccountId)
          );
          if (result) {
            loginMscServer(result);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [accounts, instance]);
  return (
    <>
      <div className="w-[100%] flex-row">
        <HeaderAdmin />
        <div className="login-container bg-center xsm:h-[calc(100vh-80px)] xs:h-[calc(100vh-96px)] xsm:text-[14px] xs:text-[15px] sm:text-[16px]">
          <div className="flex xsm:w-[100%] lg:w-[50%] h-[100%]">
            <div className="flex justify-center w-[100%]">
              <div className="flex flex-col xsm:mt-[30%] lg:mt-0 lg:justify-center">
                <div className="bg-white xsm:px-4 xsm:py-4 md:px-16 md:py-6 xl:px-20 xl:py-8 rounded-xl">
                  <div className="text-center font-bold pb-6">Login</div>
                  <div className="flex justify-center">
                    <div className=" border-t-4 border-t-[#EED484] w-[50%] pb-6"></div>
                  </div>
                  {isWaiting ? (
                    <div className="flex flex-row bg-white p-5 rounded-xl gap-2">
                      <span>Please wait a moment ...</span>
                      <SpinnerCustom />
                    </div>
                  ) : (
                    <div
                      className="w-42  h-12  bg-gray-200 items-center flex justify-center xsm:p-2 md:p-7 cursor-pointer gap-10 hover:bg-gray-300 rounded-md"
                      onClick={onSigninClick}
                    >
                      <Icon icon="logos:microsoft-icon" width={30} />
                      <button>Sign in with O365 account</button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LoginMS;
